export const overrides = theme => ({
  root: {
    maxWidth: 200,
  },
})
